/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiUpsertUserPost$Json$Any } from '../fn/user/api-upsert-user-post-json-any';
import { ApiUpsertUserPost$Json$Any$Params } from '../fn/user/api-upsert-user-post-json-any';
import { apiUpsertUserPost$Json$Json } from '../fn/user/api-upsert-user-post-json-json';
import { ApiUpsertUserPost$Json$Json$Params } from '../fn/user/api-upsert-user-post-json-json';
import { apiUpsertUserPost$Json$JsonOdataMetadataFull } from '../fn/user/api-upsert-user-post-json-json-odata-metadata-full';
import { ApiUpsertUserPost$Json$JsonOdataMetadataFull$Params } from '../fn/user/api-upsert-user-post-json-json-odata-metadata-full';
import { apiUpsertUserPost$Json$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-json-odata-metadata-full-odata-streaming-false';
import { ApiUpsertUserPost$Json$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-json-odata-metadata-full-odata-streaming-false';
import { apiUpsertUserPost$Json$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-json-odata-metadata-full-odata-streaming-true';
import { ApiUpsertUserPost$Json$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-json-odata-metadata-full-odata-streaming-true';
import { apiUpsertUserPost$Json$JsonOdataMetadataMinimal } from '../fn/user/api-upsert-user-post-json-json-odata-metadata-minimal';
import { ApiUpsertUserPost$Json$JsonOdataMetadataMinimal$Params } from '../fn/user/api-upsert-user-post-json-json-odata-metadata-minimal';
import { apiUpsertUserPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-json-odata-metadata-minimal-odata-streaming-false';
import { ApiUpsertUserPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-json-odata-metadata-minimal-odata-streaming-false';
import { apiUpsertUserPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-json-odata-metadata-minimal-odata-streaming-true';
import { ApiUpsertUserPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-json-odata-metadata-minimal-odata-streaming-true';
import { apiUpsertUserPost$Json$JsonOdataMetadataNone } from '../fn/user/api-upsert-user-post-json-json-odata-metadata-none';
import { ApiUpsertUserPost$Json$JsonOdataMetadataNone$Params } from '../fn/user/api-upsert-user-post-json-json-odata-metadata-none';
import { apiUpsertUserPost$Json$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-json-odata-metadata-none-odata-streaming-false';
import { ApiUpsertUserPost$Json$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-json-odata-metadata-none-odata-streaming-false';
import { apiUpsertUserPost$Json$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-json-odata-metadata-none-odata-streaming-true';
import { ApiUpsertUserPost$Json$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-json-odata-metadata-none-odata-streaming-true';
import { apiUpsertUserPost$Json$JsonOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-json-odata-streaming-false';
import { ApiUpsertUserPost$Json$JsonOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-json-odata-streaming-false';
import { apiUpsertUserPost$Json$JsonOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-json-odata-streaming-true';
import { ApiUpsertUserPost$Json$JsonOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-json-odata-streaming-true';
import { apiUpsertUserPost$Json$Plain } from '../fn/user/api-upsert-user-post-json-plain';
import { ApiUpsertUserPost$Json$Plain$Params } from '../fn/user/api-upsert-user-post-json-plain';
import { apiUpsertUserPost$Json$Xml } from '../fn/user/api-upsert-user-post-json-xml';
import { ApiUpsertUserPost$Json$Xml$Params } from '../fn/user/api-upsert-user-post-json-xml';
import { apiUpsertUserPost$JsonOdataMetadataFull$Any } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-any';
import { ApiUpsertUserPost$JsonOdataMetadataFull$Any$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-any';
import { apiUpsertUserPost$JsonOdataMetadataFull$Json } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-json';
import { ApiUpsertUserPost$JsonOdataMetadataFull$Json$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-json';
import { apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFull } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-json-odata-metadata-full';
import { ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFull$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-json-odata-metadata-full';
import { apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-json-odata-metadata-full-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-json-odata-metadata-full-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-json-odata-metadata-full-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-json-odata-metadata-full-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-json-odata-metadata-minimal';
import { ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-json-odata-metadata-minimal';
import { apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-json-odata-metadata-minimal-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-json-odata-metadata-minimal-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-json-odata-metadata-minimal-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-json-odata-metadata-minimal-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNone } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-json-odata-metadata-none';
import { ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNone$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-json-odata-metadata-none';
import { apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-json-odata-metadata-none-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-json-odata-metadata-none-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-json-odata-metadata-none-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-json-odata-metadata-none-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-json-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-json-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-json-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-json-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataFull$Plain } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-plain';
import { ApiUpsertUserPost$JsonOdataMetadataFull$Plain$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-plain';
import { apiUpsertUserPost$JsonOdataMetadataFull$Xml } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-xml';
import { ApiUpsertUserPost$JsonOdataMetadataFull$Xml$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-xml';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Any } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-any';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Any$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-any';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Json } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-json';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Json$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-json';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-full';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-full';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-full-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-full-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-full-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-full-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-minimal';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-minimal';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-none';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-none';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-none-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-none-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-none-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-none-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Plain } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-plain';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Plain$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-plain';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Xml } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-xml';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Xml$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-false-xml';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Any } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-any';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Any$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-any';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Json } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-json';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Json$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-json';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-full';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-full';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-full-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-full-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-full-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-full-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-minimal';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-minimal';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-none';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-none';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-none-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-none-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-none-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-none-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Plain } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-plain';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Plain$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-plain';
import { apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Xml } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-xml';
import { ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Xml$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-full-odata-streaming-true-xml';
import { apiUpsertUserPost$JsonOdataMetadataMinimal$Any } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-any';
import { ApiUpsertUserPost$JsonOdataMetadataMinimal$Any$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-any';
import { apiUpsertUserPost$JsonOdataMetadataMinimal$Json } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-json';
import { ApiUpsertUserPost$JsonOdataMetadataMinimal$Json$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-json';
import { apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-json-odata-metadata-full';
import { ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-json-odata-metadata-full';
import { apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-json-odata-metadata-full-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-json-odata-metadata-full-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-json-odata-metadata-full-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-json-odata-metadata-full-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-json-odata-metadata-minimal';
import { ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-json-odata-metadata-minimal';
import { apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-json-odata-metadata-minimal-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-json-odata-metadata-minimal-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-json-odata-metadata-minimal-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-json-odata-metadata-minimal-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-json-odata-metadata-none';
import { ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-json-odata-metadata-none';
import { apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-json-odata-metadata-none-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-json-odata-metadata-none-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-json-odata-metadata-none-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-json-odata-metadata-none-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-json-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-json-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-json-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-json-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataMinimal$Plain } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-plain';
import { ApiUpsertUserPost$JsonOdataMetadataMinimal$Plain$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-plain';
import { apiUpsertUserPost$JsonOdataMetadataMinimal$Xml } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-xml';
import { ApiUpsertUserPost$JsonOdataMetadataMinimal$Xml$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-xml';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-any';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-any';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-json';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-json';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-full';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-full';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-full-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-full-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-full-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-full-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-minimal';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-minimal';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-none';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-none';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-none-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-none-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-none-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-none-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-plain';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-plain';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-xml';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-false-xml';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-any';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-any';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-json';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-json';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-full';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-full';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-full-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-full-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-full-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-full-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-minimal';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-minimal';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-none';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-none';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-none-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-none-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-none-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-none-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-plain';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-plain';
import { apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-xml';
import { ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-minimal-odata-streaming-true-xml';
import { apiUpsertUserPost$JsonOdataMetadataNone$Any } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-any';
import { ApiUpsertUserPost$JsonOdataMetadataNone$Any$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-any';
import { apiUpsertUserPost$JsonOdataMetadataNone$Json } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-json';
import { ApiUpsertUserPost$JsonOdataMetadataNone$Json$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-json';
import { apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFull } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-json-odata-metadata-full';
import { ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFull$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-json-odata-metadata-full';
import { apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-json-odata-metadata-full-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-json-odata-metadata-full-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-json-odata-metadata-full-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-json-odata-metadata-full-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-json-odata-metadata-minimal';
import { ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-json-odata-metadata-minimal';
import { apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-json-odata-metadata-minimal-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-json-odata-metadata-minimal-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-json-odata-metadata-minimal-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-json-odata-metadata-minimal-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNone } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-json-odata-metadata-none';
import { ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNone$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-json-odata-metadata-none';
import { apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-json-odata-metadata-none-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-json-odata-metadata-none-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-json-odata-metadata-none-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-json-odata-metadata-none-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-json-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-json-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-json-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-json-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataNone$Plain } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-plain';
import { ApiUpsertUserPost$JsonOdataMetadataNone$Plain$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-plain';
import { apiUpsertUserPost$JsonOdataMetadataNone$Xml } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-xml';
import { ApiUpsertUserPost$JsonOdataMetadataNone$Xml$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-xml';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Any } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-any';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Any$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-any';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Json } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-json';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Json$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-json';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-full';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-full';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-full-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-full-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-full-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-full-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-minimal';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-minimal';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-none';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-none';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-none-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-none-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-none-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-none-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-plain';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-plain';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-xml';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-false-xml';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Any } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-any';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Any$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-any';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Json } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-json';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Json$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-json';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-full';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-full';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-full-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-full-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-full-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-full-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-minimal';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-minimal';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-none';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-none';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-none-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-none-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-none-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-none-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-plain';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-plain';
import { apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-xml';
import { ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml$Params } from '../fn/user/api-upsert-user-post-json-odata-metadata-none-odata-streaming-true-xml';
import { apiUpsertUserPost$JsonOdataStreamingFalse$Any } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-any';
import { ApiUpsertUserPost$JsonOdataStreamingFalse$Any$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-any';
import { apiUpsertUserPost$JsonOdataStreamingFalse$Json } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-json';
import { ApiUpsertUserPost$JsonOdataStreamingFalse$Json$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-json';
import { apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFull } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-json-odata-metadata-full';
import { ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFull$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-json-odata-metadata-full';
import { apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-json-odata-metadata-full-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-json-odata-metadata-full-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-json-odata-metadata-full-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-json-odata-metadata-full-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-json-odata-metadata-minimal';
import { ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-json-odata-metadata-minimal';
import { apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNone } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-json-odata-metadata-none';
import { ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNone$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-json-odata-metadata-none';
import { apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-json-odata-metadata-none-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-json-odata-metadata-none-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-json-odata-metadata-none-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-json-odata-metadata-none-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-json-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-json-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-json-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-json-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataStreamingFalse$Plain } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-plain';
import { ApiUpsertUserPost$JsonOdataStreamingFalse$Plain$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-plain';
import { apiUpsertUserPost$JsonOdataStreamingFalse$Xml } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-xml';
import { ApiUpsertUserPost$JsonOdataStreamingFalse$Xml$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-false-xml';
import { apiUpsertUserPost$JsonOdataStreamingTrue$Any } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-any';
import { ApiUpsertUserPost$JsonOdataStreamingTrue$Any$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-any';
import { apiUpsertUserPost$JsonOdataStreamingTrue$Json } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-json';
import { ApiUpsertUserPost$JsonOdataStreamingTrue$Json$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-json';
import { apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFull } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-json-odata-metadata-full';
import { ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFull$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-json-odata-metadata-full';
import { apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-json-odata-metadata-full-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-json-odata-metadata-full-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-json-odata-metadata-full-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-json-odata-metadata-full-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-json-odata-metadata-minimal';
import { ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-json-odata-metadata-minimal';
import { apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNone } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-json-odata-metadata-none';
import { ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNone$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-json-odata-metadata-none';
import { apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-json-odata-metadata-none-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-json-odata-metadata-none-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-json-odata-metadata-none-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-json-odata-metadata-none-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-json-odata-streaming-false';
import { ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-json-odata-streaming-false';
import { apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-json-odata-streaming-true';
import { ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-json-odata-streaming-true';
import { apiUpsertUserPost$JsonOdataStreamingTrue$Plain } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-plain';
import { ApiUpsertUserPost$JsonOdataStreamingTrue$Plain$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-plain';
import { apiUpsertUserPost$JsonOdataStreamingTrue$Xml } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-xml';
import { ApiUpsertUserPost$JsonOdataStreamingTrue$Xml$Params } from '../fn/user/api-upsert-user-post-json-odata-streaming-true-xml';
import { apiUpsertUserPost$Plain$Any } from '../fn/user/api-upsert-user-post-plain-any';
import { ApiUpsertUserPost$Plain$Any$Params } from '../fn/user/api-upsert-user-post-plain-any';
import { apiUpsertUserPost$Plain$Json } from '../fn/user/api-upsert-user-post-plain-json';
import { ApiUpsertUserPost$Plain$Json$Params } from '../fn/user/api-upsert-user-post-plain-json';
import { apiUpsertUserPost$Plain$JsonOdataMetadataFull } from '../fn/user/api-upsert-user-post-plain-json-odata-metadata-full';
import { ApiUpsertUserPost$Plain$JsonOdataMetadataFull$Params } from '../fn/user/api-upsert-user-post-plain-json-odata-metadata-full';
import { apiUpsertUserPost$Plain$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/api-upsert-user-post-plain-json-odata-metadata-full-odata-streaming-false';
import { ApiUpsertUserPost$Plain$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-plain-json-odata-metadata-full-odata-streaming-false';
import { apiUpsertUserPost$Plain$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/api-upsert-user-post-plain-json-odata-metadata-full-odata-streaming-true';
import { ApiUpsertUserPost$Plain$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-plain-json-odata-metadata-full-odata-streaming-true';
import { apiUpsertUserPost$Plain$JsonOdataMetadataMinimal } from '../fn/user/api-upsert-user-post-plain-json-odata-metadata-minimal';
import { ApiUpsertUserPost$Plain$JsonOdataMetadataMinimal$Params } from '../fn/user/api-upsert-user-post-plain-json-odata-metadata-minimal';
import { apiUpsertUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/api-upsert-user-post-plain-json-odata-metadata-minimal-odata-streaming-false';
import { ApiUpsertUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-plain-json-odata-metadata-minimal-odata-streaming-false';
import { apiUpsertUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/api-upsert-user-post-plain-json-odata-metadata-minimal-odata-streaming-true';
import { ApiUpsertUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-plain-json-odata-metadata-minimal-odata-streaming-true';
import { apiUpsertUserPost$Plain$JsonOdataMetadataNone } from '../fn/user/api-upsert-user-post-plain-json-odata-metadata-none';
import { ApiUpsertUserPost$Plain$JsonOdataMetadataNone$Params } from '../fn/user/api-upsert-user-post-plain-json-odata-metadata-none';
import { apiUpsertUserPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/api-upsert-user-post-plain-json-odata-metadata-none-odata-streaming-false';
import { ApiUpsertUserPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-plain-json-odata-metadata-none-odata-streaming-false';
import { apiUpsertUserPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/api-upsert-user-post-plain-json-odata-metadata-none-odata-streaming-true';
import { ApiUpsertUserPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-plain-json-odata-metadata-none-odata-streaming-true';
import { apiUpsertUserPost$Plain$JsonOdataStreamingFalse } from '../fn/user/api-upsert-user-post-plain-json-odata-streaming-false';
import { ApiUpsertUserPost$Plain$JsonOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-plain-json-odata-streaming-false';
import { apiUpsertUserPost$Plain$JsonOdataStreamingTrue } from '../fn/user/api-upsert-user-post-plain-json-odata-streaming-true';
import { ApiUpsertUserPost$Plain$JsonOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-plain-json-odata-streaming-true';
import { apiUpsertUserPost$Plain$Plain } from '../fn/user/api-upsert-user-post-plain-plain';
import { ApiUpsertUserPost$Plain$Plain$Params } from '../fn/user/api-upsert-user-post-plain-plain';
import { apiUpsertUserPost$Plain$Xml } from '../fn/user/api-upsert-user-post-plain-xml';
import { ApiUpsertUserPost$Plain$Xml$Params } from '../fn/user/api-upsert-user-post-plain-xml';
import { apiUpsertUserPost$Xml$Any } from '../fn/user/api-upsert-user-post-xml-any';
import { ApiUpsertUserPost$Xml$Any$Params } from '../fn/user/api-upsert-user-post-xml-any';
import { apiUpsertUserPost$Xml$Json } from '../fn/user/api-upsert-user-post-xml-json';
import { ApiUpsertUserPost$Xml$Json$Params } from '../fn/user/api-upsert-user-post-xml-json';
import { apiUpsertUserPost$Xml$JsonOdataMetadataFull } from '../fn/user/api-upsert-user-post-xml-json-odata-metadata-full';
import { ApiUpsertUserPost$Xml$JsonOdataMetadataFull$Params } from '../fn/user/api-upsert-user-post-xml-json-odata-metadata-full';
import { apiUpsertUserPost$Xml$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/api-upsert-user-post-xml-json-odata-metadata-full-odata-streaming-false';
import { ApiUpsertUserPost$Xml$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-xml-json-odata-metadata-full-odata-streaming-false';
import { apiUpsertUserPost$Xml$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/api-upsert-user-post-xml-json-odata-metadata-full-odata-streaming-true';
import { ApiUpsertUserPost$Xml$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-xml-json-odata-metadata-full-odata-streaming-true';
import { apiUpsertUserPost$Xml$JsonOdataMetadataMinimal } from '../fn/user/api-upsert-user-post-xml-json-odata-metadata-minimal';
import { ApiUpsertUserPost$Xml$JsonOdataMetadataMinimal$Params } from '../fn/user/api-upsert-user-post-xml-json-odata-metadata-minimal';
import { apiUpsertUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/api-upsert-user-post-xml-json-odata-metadata-minimal-odata-streaming-false';
import { ApiUpsertUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-xml-json-odata-metadata-minimal-odata-streaming-false';
import { apiUpsertUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/api-upsert-user-post-xml-json-odata-metadata-minimal-odata-streaming-true';
import { ApiUpsertUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-xml-json-odata-metadata-minimal-odata-streaming-true';
import { apiUpsertUserPost$Xml$JsonOdataMetadataNone } from '../fn/user/api-upsert-user-post-xml-json-odata-metadata-none';
import { ApiUpsertUserPost$Xml$JsonOdataMetadataNone$Params } from '../fn/user/api-upsert-user-post-xml-json-odata-metadata-none';
import { apiUpsertUserPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/api-upsert-user-post-xml-json-odata-metadata-none-odata-streaming-false';
import { ApiUpsertUserPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-xml-json-odata-metadata-none-odata-streaming-false';
import { apiUpsertUserPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/api-upsert-user-post-xml-json-odata-metadata-none-odata-streaming-true';
import { ApiUpsertUserPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-xml-json-odata-metadata-none-odata-streaming-true';
import { apiUpsertUserPost$Xml$JsonOdataStreamingFalse } from '../fn/user/api-upsert-user-post-xml-json-odata-streaming-false';
import { ApiUpsertUserPost$Xml$JsonOdataStreamingFalse$Params } from '../fn/user/api-upsert-user-post-xml-json-odata-streaming-false';
import { apiUpsertUserPost$Xml$JsonOdataStreamingTrue } from '../fn/user/api-upsert-user-post-xml-json-odata-streaming-true';
import { ApiUpsertUserPost$Xml$JsonOdataStreamingTrue$Params } from '../fn/user/api-upsert-user-post-xml-json-odata-streaming-true';
import { apiUpsertUserPost$Xml$Plain } from '../fn/user/api-upsert-user-post-xml-plain';
import { ApiUpsertUserPost$Xml$Plain$Params } from '../fn/user/api-upsert-user-post-xml-plain';
import { apiUpsertUserPost$Xml$Xml } from '../fn/user/api-upsert-user-post-xml-xml';
import { ApiUpsertUserPost$Xml$Xml$Params } from '../fn/user/api-upsert-user-post-xml-xml';
import { apiUserPermissionsGet } from '../fn/user/api-user-permissions-get';
import { ApiUserPermissionsGet$Params } from '../fn/user/api-user-permissions-get';
import { apiUserPost$Json$Any } from '../fn/user/api-user-post-json-any';
import { ApiUserPost$Json$Any$Params } from '../fn/user/api-user-post-json-any';
import { apiUserPost$Json$Json } from '../fn/user/api-user-post-json-json';
import { ApiUserPost$Json$Json$Params } from '../fn/user/api-user-post-json-json';
import { apiUserPost$Json$JsonOdataMetadataFull } from '../fn/user/api-user-post-json-json-odata-metadata-full';
import { ApiUserPost$Json$JsonOdataMetadataFull$Params } from '../fn/user/api-user-post-json-json-odata-metadata-full';
import { apiUserPost$Json$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/api-user-post-json-json-odata-metadata-full-odata-streaming-false';
import { ApiUserPost$Json$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-json-odata-metadata-full-odata-streaming-false';
import { apiUserPost$Json$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/api-user-post-json-json-odata-metadata-full-odata-streaming-true';
import { ApiUserPost$Json$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-json-odata-metadata-full-odata-streaming-true';
import { apiUserPost$Json$JsonOdataMetadataMinimal } from '../fn/user/api-user-post-json-json-odata-metadata-minimal';
import { ApiUserPost$Json$JsonOdataMetadataMinimal$Params } from '../fn/user/api-user-post-json-json-odata-metadata-minimal';
import { apiUserPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/api-user-post-json-json-odata-metadata-minimal-odata-streaming-false';
import { ApiUserPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-json-odata-metadata-minimal-odata-streaming-false';
import { apiUserPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/api-user-post-json-json-odata-metadata-minimal-odata-streaming-true';
import { ApiUserPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-json-odata-metadata-minimal-odata-streaming-true';
import { apiUserPost$Json$JsonOdataMetadataNone } from '../fn/user/api-user-post-json-json-odata-metadata-none';
import { ApiUserPost$Json$JsonOdataMetadataNone$Params } from '../fn/user/api-user-post-json-json-odata-metadata-none';
import { apiUserPost$Json$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/api-user-post-json-json-odata-metadata-none-odata-streaming-false';
import { ApiUserPost$Json$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-json-odata-metadata-none-odata-streaming-false';
import { apiUserPost$Json$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/api-user-post-json-json-odata-metadata-none-odata-streaming-true';
import { ApiUserPost$Json$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-json-odata-metadata-none-odata-streaming-true';
import { apiUserPost$Json$JsonOdataStreamingFalse } from '../fn/user/api-user-post-json-json-odata-streaming-false';
import { ApiUserPost$Json$JsonOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-json-odata-streaming-false';
import { apiUserPost$Json$JsonOdataStreamingTrue } from '../fn/user/api-user-post-json-json-odata-streaming-true';
import { ApiUserPost$Json$JsonOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-json-odata-streaming-true';
import { apiUserPost$Json$Plain } from '../fn/user/api-user-post-json-plain';
import { ApiUserPost$Json$Plain$Params } from '../fn/user/api-user-post-json-plain';
import { apiUserPost$Json$Xml } from '../fn/user/api-user-post-json-xml';
import { ApiUserPost$Json$Xml$Params } from '../fn/user/api-user-post-json-xml';
import { apiUserPost$JsonOdataMetadataFull$Any } from '../fn/user/api-user-post-json-odata-metadata-full-any';
import { ApiUserPost$JsonOdataMetadataFull$Any$Params } from '../fn/user/api-user-post-json-odata-metadata-full-any';
import { apiUserPost$JsonOdataMetadataFull$Json } from '../fn/user/api-user-post-json-odata-metadata-full-json';
import { ApiUserPost$JsonOdataMetadataFull$Json$Params } from '../fn/user/api-user-post-json-odata-metadata-full-json';
import { apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFull } from '../fn/user/api-user-post-json-odata-metadata-full-json-odata-metadata-full';
import { ApiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFull$Params } from '../fn/user/api-user-post-json-odata-metadata-full-json-odata-metadata-full';
import { apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-full-json-odata-metadata-full-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-full-json-odata-metadata-full-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-full-json-odata-metadata-full-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-full-json-odata-metadata-full-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal } from '../fn/user/api-user-post-json-odata-metadata-full-json-odata-metadata-minimal';
import { ApiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal$Params } from '../fn/user/api-user-post-json-odata-metadata-full-json-odata-metadata-minimal';
import { apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-full-json-odata-metadata-minimal-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-full-json-odata-metadata-minimal-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-full-json-odata-metadata-minimal-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-full-json-odata-metadata-minimal-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNone } from '../fn/user/api-user-post-json-odata-metadata-full-json-odata-metadata-none';
import { ApiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNone$Params } from '../fn/user/api-user-post-json-odata-metadata-full-json-odata-metadata-none';
import { apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-full-json-odata-metadata-none-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-full-json-odata-metadata-none-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-full-json-odata-metadata-none-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-full-json-odata-metadata-none-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataFull$JsonOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-full-json-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataFull$JsonOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-full-json-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataFull$JsonOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-full-json-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataFull$JsonOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-full-json-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataFull$Plain } from '../fn/user/api-user-post-json-odata-metadata-full-plain';
import { ApiUserPost$JsonOdataMetadataFull$Plain$Params } from '../fn/user/api-user-post-json-odata-metadata-full-plain';
import { apiUserPost$JsonOdataMetadataFull$Xml } from '../fn/user/api-user-post-json-odata-metadata-full-xml';
import { ApiUserPost$JsonOdataMetadataFull$Xml$Params } from '../fn/user/api-user-post-json-odata-metadata-full-xml';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Any } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-any';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Any$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-any';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Json } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-json';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Json$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-json';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-full';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-full';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-full-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-full-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-full-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-full-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-minimal';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-minimal';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-none';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-none';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-none-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-none-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-none-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-metadata-none-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-json-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Plain } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-plain';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Plain$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-plain';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Xml } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-xml';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Xml$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-false-xml';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Any } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-any';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Any$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-any';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Json } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-json';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Json$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-json';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-full';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-full';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-full-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-full-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-full-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-full-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-minimal';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-minimal';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-none';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-none';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-none-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-none-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-none-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-metadata-none-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-json-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Plain } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-plain';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Plain$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-plain';
import { apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Xml } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-xml';
import { ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Xml$Params } from '../fn/user/api-user-post-json-odata-metadata-full-odata-streaming-true-xml';
import { apiUserPost$JsonOdataMetadataMinimal$Any } from '../fn/user/api-user-post-json-odata-metadata-minimal-any';
import { ApiUserPost$JsonOdataMetadataMinimal$Any$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-any';
import { apiUserPost$JsonOdataMetadataMinimal$Json } from '../fn/user/api-user-post-json-odata-metadata-minimal-json';
import { ApiUserPost$JsonOdataMetadataMinimal$Json$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-json';
import { apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull } from '../fn/user/api-user-post-json-odata-metadata-minimal-json-odata-metadata-full';
import { ApiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-json-odata-metadata-full';
import { apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-minimal-json-odata-metadata-full-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-json-odata-metadata-full-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-minimal-json-odata-metadata-full-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-json-odata-metadata-full-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal } from '../fn/user/api-user-post-json-odata-metadata-minimal-json-odata-metadata-minimal';
import { ApiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-json-odata-metadata-minimal';
import { apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-minimal-json-odata-metadata-minimal-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-json-odata-metadata-minimal-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-minimal-json-odata-metadata-minimal-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-json-odata-metadata-minimal-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone } from '../fn/user/api-user-post-json-odata-metadata-minimal-json-odata-metadata-none';
import { ApiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-json-odata-metadata-none';
import { apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-minimal-json-odata-metadata-none-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-json-odata-metadata-none-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-minimal-json-odata-metadata-none-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-json-odata-metadata-none-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-minimal-json-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-json-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-minimal-json-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-json-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataMinimal$Plain } from '../fn/user/api-user-post-json-odata-metadata-minimal-plain';
import { ApiUserPost$JsonOdataMetadataMinimal$Plain$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-plain';
import { apiUserPost$JsonOdataMetadataMinimal$Xml } from '../fn/user/api-user-post-json-odata-metadata-minimal-xml';
import { ApiUserPost$JsonOdataMetadataMinimal$Xml$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-xml';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-any';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-any';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-json';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-json';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-full';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-full';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-full-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-full-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-full-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-full-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-minimal';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-minimal';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-none';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-none';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-none-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-none-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-none-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-metadata-none-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-json-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-plain';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-plain';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-xml';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-false-xml';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-any';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-any';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-json';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-json';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-full';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-full';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-full-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-full-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-full-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-full-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-minimal';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-minimal';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-none';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-none';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-none-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-none-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-none-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-metadata-none-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-json-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-plain';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-plain';
import { apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-xml';
import { ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml$Params } from '../fn/user/api-user-post-json-odata-metadata-minimal-odata-streaming-true-xml';
import { apiUserPost$JsonOdataMetadataNone$Any } from '../fn/user/api-user-post-json-odata-metadata-none-any';
import { ApiUserPost$JsonOdataMetadataNone$Any$Params } from '../fn/user/api-user-post-json-odata-metadata-none-any';
import { apiUserPost$JsonOdataMetadataNone$Json } from '../fn/user/api-user-post-json-odata-metadata-none-json';
import { ApiUserPost$JsonOdataMetadataNone$Json$Params } from '../fn/user/api-user-post-json-odata-metadata-none-json';
import { apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFull } from '../fn/user/api-user-post-json-odata-metadata-none-json-odata-metadata-full';
import { ApiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFull$Params } from '../fn/user/api-user-post-json-odata-metadata-none-json-odata-metadata-full';
import { apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-none-json-odata-metadata-full-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-none-json-odata-metadata-full-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-none-json-odata-metadata-full-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-none-json-odata-metadata-full-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal } from '../fn/user/api-user-post-json-odata-metadata-none-json-odata-metadata-minimal';
import { ApiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal$Params } from '../fn/user/api-user-post-json-odata-metadata-none-json-odata-metadata-minimal';
import { apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-none-json-odata-metadata-minimal-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-none-json-odata-metadata-minimal-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-none-json-odata-metadata-minimal-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-none-json-odata-metadata-minimal-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNone } from '../fn/user/api-user-post-json-odata-metadata-none-json-odata-metadata-none';
import { ApiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNone$Params } from '../fn/user/api-user-post-json-odata-metadata-none-json-odata-metadata-none';
import { apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-none-json-odata-metadata-none-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-none-json-odata-metadata-none-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-none-json-odata-metadata-none-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-none-json-odata-metadata-none-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataNone$JsonOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-none-json-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataNone$JsonOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-none-json-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataNone$JsonOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-none-json-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataNone$JsonOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-none-json-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataNone$Plain } from '../fn/user/api-user-post-json-odata-metadata-none-plain';
import { ApiUserPost$JsonOdataMetadataNone$Plain$Params } from '../fn/user/api-user-post-json-odata-metadata-none-plain';
import { apiUserPost$JsonOdataMetadataNone$Xml } from '../fn/user/api-user-post-json-odata-metadata-none-xml';
import { ApiUserPost$JsonOdataMetadataNone$Xml$Params } from '../fn/user/api-user-post-json-odata-metadata-none-xml';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Any } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-any';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Any$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-any';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Json } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-json';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Json$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-json';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-full';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-full';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-full-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-full-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-full-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-full-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-minimal';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-minimal';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-none';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-none';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-none-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-none-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-none-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-metadata-none-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-json-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-plain';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-plain';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-xml';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-false-xml';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Any } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-any';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Any$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-any';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Json } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-json';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Json$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-json';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-full';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-full';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-full-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-full-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-full-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-full-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-minimal';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-minimal';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-none';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-none';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-none-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-none-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-none-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-metadata-none-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-streaming-false';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-streaming-false';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-streaming-true';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-json-odata-streaming-true';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-plain';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-plain';
import { apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-xml';
import { ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml$Params } from '../fn/user/api-user-post-json-odata-metadata-none-odata-streaming-true-xml';
import { apiUserPost$JsonOdataStreamingFalse$Any } from '../fn/user/api-user-post-json-odata-streaming-false-any';
import { ApiUserPost$JsonOdataStreamingFalse$Any$Params } from '../fn/user/api-user-post-json-odata-streaming-false-any';
import { apiUserPost$JsonOdataStreamingFalse$Json } from '../fn/user/api-user-post-json-odata-streaming-false-json';
import { ApiUserPost$JsonOdataStreamingFalse$Json$Params } from '../fn/user/api-user-post-json-odata-streaming-false-json';
import { apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFull } from '../fn/user/api-user-post-json-odata-streaming-false-json-odata-metadata-full';
import { ApiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFull$Params } from '../fn/user/api-user-post-json-odata-streaming-false-json-odata-metadata-full';
import { apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-streaming-false-json-odata-metadata-full-odata-streaming-false';
import { ApiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-streaming-false-json-odata-metadata-full-odata-streaming-false';
import { apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-streaming-false-json-odata-metadata-full-odata-streaming-true';
import { ApiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-streaming-false-json-odata-metadata-full-odata-streaming-true';
import { apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal } from '../fn/user/api-user-post-json-odata-streaming-false-json-odata-metadata-minimal';
import { ApiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal$Params } from '../fn/user/api-user-post-json-odata-streaming-false-json-odata-metadata-minimal';
import { apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-false';
import { ApiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-false';
import { apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-true';
import { ApiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-streaming-false-json-odata-metadata-minimal-odata-streaming-true';
import { apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNone } from '../fn/user/api-user-post-json-odata-streaming-false-json-odata-metadata-none';
import { ApiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNone$Params } from '../fn/user/api-user-post-json-odata-streaming-false-json-odata-metadata-none';
import { apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-streaming-false-json-odata-metadata-none-odata-streaming-false';
import { ApiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-streaming-false-json-odata-metadata-none-odata-streaming-false';
import { apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-streaming-false-json-odata-metadata-none-odata-streaming-true';
import { ApiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-streaming-false-json-odata-metadata-none-odata-streaming-true';
import { apiUserPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-streaming-false-json-odata-streaming-false';
import { ApiUserPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-streaming-false-json-odata-streaming-false';
import { apiUserPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-streaming-false-json-odata-streaming-true';
import { ApiUserPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-streaming-false-json-odata-streaming-true';
import { apiUserPost$JsonOdataStreamingFalse$Plain } from '../fn/user/api-user-post-json-odata-streaming-false-plain';
import { ApiUserPost$JsonOdataStreamingFalse$Plain$Params } from '../fn/user/api-user-post-json-odata-streaming-false-plain';
import { apiUserPost$JsonOdataStreamingFalse$Xml } from '../fn/user/api-user-post-json-odata-streaming-false-xml';
import { ApiUserPost$JsonOdataStreamingFalse$Xml$Params } from '../fn/user/api-user-post-json-odata-streaming-false-xml';
import { apiUserPost$JsonOdataStreamingTrue$Any } from '../fn/user/api-user-post-json-odata-streaming-true-any';
import { ApiUserPost$JsonOdataStreamingTrue$Any$Params } from '../fn/user/api-user-post-json-odata-streaming-true-any';
import { apiUserPost$JsonOdataStreamingTrue$Json } from '../fn/user/api-user-post-json-odata-streaming-true-json';
import { ApiUserPost$JsonOdataStreamingTrue$Json$Params } from '../fn/user/api-user-post-json-odata-streaming-true-json';
import { apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFull } from '../fn/user/api-user-post-json-odata-streaming-true-json-odata-metadata-full';
import { ApiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFull$Params } from '../fn/user/api-user-post-json-odata-streaming-true-json-odata-metadata-full';
import { apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-streaming-true-json-odata-metadata-full-odata-streaming-false';
import { ApiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-streaming-true-json-odata-metadata-full-odata-streaming-false';
import { apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-streaming-true-json-odata-metadata-full-odata-streaming-true';
import { ApiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-streaming-true-json-odata-metadata-full-odata-streaming-true';
import { apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal } from '../fn/user/api-user-post-json-odata-streaming-true-json-odata-metadata-minimal';
import { ApiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal$Params } from '../fn/user/api-user-post-json-odata-streaming-true-json-odata-metadata-minimal';
import { apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-false';
import { ApiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-false';
import { apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-true';
import { ApiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-streaming-true-json-odata-metadata-minimal-odata-streaming-true';
import { apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNone } from '../fn/user/api-user-post-json-odata-streaming-true-json-odata-metadata-none';
import { ApiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNone$Params } from '../fn/user/api-user-post-json-odata-streaming-true-json-odata-metadata-none';
import { apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-streaming-true-json-odata-metadata-none-odata-streaming-false';
import { ApiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-streaming-true-json-odata-metadata-none-odata-streaming-false';
import { apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-streaming-true-json-odata-metadata-none-odata-streaming-true';
import { ApiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-streaming-true-json-odata-metadata-none-odata-streaming-true';
import { apiUserPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse } from '../fn/user/api-user-post-json-odata-streaming-true-json-odata-streaming-false';
import { ApiUserPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse$Params } from '../fn/user/api-user-post-json-odata-streaming-true-json-odata-streaming-false';
import { apiUserPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue } from '../fn/user/api-user-post-json-odata-streaming-true-json-odata-streaming-true';
import { ApiUserPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue$Params } from '../fn/user/api-user-post-json-odata-streaming-true-json-odata-streaming-true';
import { apiUserPost$JsonOdataStreamingTrue$Plain } from '../fn/user/api-user-post-json-odata-streaming-true-plain';
import { ApiUserPost$JsonOdataStreamingTrue$Plain$Params } from '../fn/user/api-user-post-json-odata-streaming-true-plain';
import { apiUserPost$JsonOdataStreamingTrue$Xml } from '../fn/user/api-user-post-json-odata-streaming-true-xml';
import { ApiUserPost$JsonOdataStreamingTrue$Xml$Params } from '../fn/user/api-user-post-json-odata-streaming-true-xml';
import { apiUserPost$Plain$Any } from '../fn/user/api-user-post-plain-any';
import { ApiUserPost$Plain$Any$Params } from '../fn/user/api-user-post-plain-any';
import { apiUserPost$Plain$Json } from '../fn/user/api-user-post-plain-json';
import { ApiUserPost$Plain$Json$Params } from '../fn/user/api-user-post-plain-json';
import { apiUserPost$Plain$JsonOdataMetadataFull } from '../fn/user/api-user-post-plain-json-odata-metadata-full';
import { ApiUserPost$Plain$JsonOdataMetadataFull$Params } from '../fn/user/api-user-post-plain-json-odata-metadata-full';
import { apiUserPost$Plain$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/api-user-post-plain-json-odata-metadata-full-odata-streaming-false';
import { ApiUserPost$Plain$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/api-user-post-plain-json-odata-metadata-full-odata-streaming-false';
import { apiUserPost$Plain$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/api-user-post-plain-json-odata-metadata-full-odata-streaming-true';
import { ApiUserPost$Plain$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/api-user-post-plain-json-odata-metadata-full-odata-streaming-true';
import { apiUserPost$Plain$JsonOdataMetadataMinimal } from '../fn/user/api-user-post-plain-json-odata-metadata-minimal';
import { ApiUserPost$Plain$JsonOdataMetadataMinimal$Params } from '../fn/user/api-user-post-plain-json-odata-metadata-minimal';
import { apiUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/api-user-post-plain-json-odata-metadata-minimal-odata-streaming-false';
import { ApiUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/api-user-post-plain-json-odata-metadata-minimal-odata-streaming-false';
import { apiUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/api-user-post-plain-json-odata-metadata-minimal-odata-streaming-true';
import { ApiUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/api-user-post-plain-json-odata-metadata-minimal-odata-streaming-true';
import { apiUserPost$Plain$JsonOdataMetadataNone } from '../fn/user/api-user-post-plain-json-odata-metadata-none';
import { ApiUserPost$Plain$JsonOdataMetadataNone$Params } from '../fn/user/api-user-post-plain-json-odata-metadata-none';
import { apiUserPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/api-user-post-plain-json-odata-metadata-none-odata-streaming-false';
import { ApiUserPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/api-user-post-plain-json-odata-metadata-none-odata-streaming-false';
import { apiUserPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/api-user-post-plain-json-odata-metadata-none-odata-streaming-true';
import { ApiUserPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/api-user-post-plain-json-odata-metadata-none-odata-streaming-true';
import { apiUserPost$Plain$JsonOdataStreamingFalse } from '../fn/user/api-user-post-plain-json-odata-streaming-false';
import { ApiUserPost$Plain$JsonOdataStreamingFalse$Params } from '../fn/user/api-user-post-plain-json-odata-streaming-false';
import { apiUserPost$Plain$JsonOdataStreamingTrue } from '../fn/user/api-user-post-plain-json-odata-streaming-true';
import { ApiUserPost$Plain$JsonOdataStreamingTrue$Params } from '../fn/user/api-user-post-plain-json-odata-streaming-true';
import { apiUserPost$Plain$Plain } from '../fn/user/api-user-post-plain-plain';
import { ApiUserPost$Plain$Plain$Params } from '../fn/user/api-user-post-plain-plain';
import { apiUserPost$Plain$Xml } from '../fn/user/api-user-post-plain-xml';
import { ApiUserPost$Plain$Xml$Params } from '../fn/user/api-user-post-plain-xml';
import { apiUserPost$Xml$Any } from '../fn/user/api-user-post-xml-any';
import { ApiUserPost$Xml$Any$Params } from '../fn/user/api-user-post-xml-any';
import { apiUserPost$Xml$Json } from '../fn/user/api-user-post-xml-json';
import { ApiUserPost$Xml$Json$Params } from '../fn/user/api-user-post-xml-json';
import { apiUserPost$Xml$JsonOdataMetadataFull } from '../fn/user/api-user-post-xml-json-odata-metadata-full';
import { ApiUserPost$Xml$JsonOdataMetadataFull$Params } from '../fn/user/api-user-post-xml-json-odata-metadata-full';
import { apiUserPost$Xml$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/api-user-post-xml-json-odata-metadata-full-odata-streaming-false';
import { ApiUserPost$Xml$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/api-user-post-xml-json-odata-metadata-full-odata-streaming-false';
import { apiUserPost$Xml$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/api-user-post-xml-json-odata-metadata-full-odata-streaming-true';
import { ApiUserPost$Xml$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/api-user-post-xml-json-odata-metadata-full-odata-streaming-true';
import { apiUserPost$Xml$JsonOdataMetadataMinimal } from '../fn/user/api-user-post-xml-json-odata-metadata-minimal';
import { ApiUserPost$Xml$JsonOdataMetadataMinimal$Params } from '../fn/user/api-user-post-xml-json-odata-metadata-minimal';
import { apiUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/api-user-post-xml-json-odata-metadata-minimal-odata-streaming-false';
import { ApiUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/api-user-post-xml-json-odata-metadata-minimal-odata-streaming-false';
import { apiUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/api-user-post-xml-json-odata-metadata-minimal-odata-streaming-true';
import { ApiUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/api-user-post-xml-json-odata-metadata-minimal-odata-streaming-true';
import { apiUserPost$Xml$JsonOdataMetadataNone } from '../fn/user/api-user-post-xml-json-odata-metadata-none';
import { ApiUserPost$Xml$JsonOdataMetadataNone$Params } from '../fn/user/api-user-post-xml-json-odata-metadata-none';
import { apiUserPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/api-user-post-xml-json-odata-metadata-none-odata-streaming-false';
import { ApiUserPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/api-user-post-xml-json-odata-metadata-none-odata-streaming-false';
import { apiUserPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/api-user-post-xml-json-odata-metadata-none-odata-streaming-true';
import { ApiUserPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/api-user-post-xml-json-odata-metadata-none-odata-streaming-true';
import { apiUserPost$Xml$JsonOdataStreamingFalse } from '../fn/user/api-user-post-xml-json-odata-streaming-false';
import { ApiUserPost$Xml$JsonOdataStreamingFalse$Params } from '../fn/user/api-user-post-xml-json-odata-streaming-false';
import { apiUserPost$Xml$JsonOdataStreamingTrue } from '../fn/user/api-user-post-xml-json-odata-streaming-true';
import { ApiUserPost$Xml$JsonOdataStreamingTrue$Params } from '../fn/user/api-user-post-xml-json-odata-streaming-true';
import { apiUserPost$Xml$Plain } from '../fn/user/api-user-post-xml-plain';
import { ApiUserPost$Xml$Plain$Params } from '../fn/user/api-user-post-xml-plain';
import { apiUserPost$Xml$Xml } from '../fn/user/api-user-post-xml-xml';
import { ApiUserPost$Xml$Xml$Params } from '../fn/user/api-user-post-xml-xml';
import { ObjectResult } from '../models/object-result';
import { odataUser$Any } from '../fn/user/odata-user-any';
import { OdataUser$Any$Params } from '../fn/user/odata-user-any';
import { odataUser$Json } from '../fn/user/odata-user-json';
import { OdataUser$Json$Params } from '../fn/user/odata-user-json';
import { odataUser$JsonOdataMetadataFull } from '../fn/user/odata-user-json-odata-metadata-full';
import { OdataUser$JsonOdataMetadataFull$Params } from '../fn/user/odata-user-json-odata-metadata-full';
import { odataUser$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/odata-user-json-odata-metadata-full-odata-streaming-false';
import { OdataUser$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/odata-user-json-odata-metadata-full-odata-streaming-false';
import { odataUser$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/odata-user-json-odata-metadata-full-odata-streaming-true';
import { OdataUser$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/odata-user-json-odata-metadata-full-odata-streaming-true';
import { odataUser$JsonOdataMetadataMinimal } from '../fn/user/odata-user-json-odata-metadata-minimal';
import { OdataUser$JsonOdataMetadataMinimal$Params } from '../fn/user/odata-user-json-odata-metadata-minimal';
import { odataUser$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/odata-user-json-odata-metadata-minimal-odata-streaming-false';
import { OdataUser$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/odata-user-json-odata-metadata-minimal-odata-streaming-false';
import { odataUser$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/odata-user-json-odata-metadata-minimal-odata-streaming-true';
import { OdataUser$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/odata-user-json-odata-metadata-minimal-odata-streaming-true';
import { odataUser$JsonOdataMetadataNone } from '../fn/user/odata-user-json-odata-metadata-none';
import { OdataUser$JsonOdataMetadataNone$Params } from '../fn/user/odata-user-json-odata-metadata-none';
import { odataUser$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/odata-user-json-odata-metadata-none-odata-streaming-false';
import { OdataUser$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/odata-user-json-odata-metadata-none-odata-streaming-false';
import { odataUser$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/odata-user-json-odata-metadata-none-odata-streaming-true';
import { OdataUser$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/odata-user-json-odata-metadata-none-odata-streaming-true';
import { odataUser$JsonOdataStreamingFalse } from '../fn/user/odata-user-json-odata-streaming-false';
import { OdataUser$JsonOdataStreamingFalse$Params } from '../fn/user/odata-user-json-odata-streaming-false';
import { odataUser$JsonOdataStreamingTrue } from '../fn/user/odata-user-json-odata-streaming-true';
import { OdataUser$JsonOdataStreamingTrue$Params } from '../fn/user/odata-user-json-odata-streaming-true';
import { odataUser$Plain } from '../fn/user/odata-user-plain';
import { OdataUser$Plain$Params } from '../fn/user/odata-user-plain';
import { odataUser$Xml } from '../fn/user/odata-user-xml';
import { OdataUser$Xml$Params } from '../fn/user/odata-user-xml';
import { odataUserCount$Any } from '../fn/user/odata-user-count-any';
import { OdataUserCount$Any$Params } from '../fn/user/odata-user-count-any';
import { odataUserCount$Json } from '../fn/user/odata-user-count-json';
import { OdataUserCount$Json$Params } from '../fn/user/odata-user-count-json';
import { odataUserCount$JsonOdataMetadataFull } from '../fn/user/odata-user-count-json-odata-metadata-full';
import { OdataUserCount$JsonOdataMetadataFull$Params } from '../fn/user/odata-user-count-json-odata-metadata-full';
import { odataUserCount$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/user/odata-user-count-json-odata-metadata-full-odata-streaming-false';
import { OdataUserCount$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/user/odata-user-count-json-odata-metadata-full-odata-streaming-false';
import { odataUserCount$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/user/odata-user-count-json-odata-metadata-full-odata-streaming-true';
import { OdataUserCount$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/user/odata-user-count-json-odata-metadata-full-odata-streaming-true';
import { odataUserCount$JsonOdataMetadataMinimal } from '../fn/user/odata-user-count-json-odata-metadata-minimal';
import { OdataUserCount$JsonOdataMetadataMinimal$Params } from '../fn/user/odata-user-count-json-odata-metadata-minimal';
import { odataUserCount$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/user/odata-user-count-json-odata-metadata-minimal-odata-streaming-false';
import { OdataUserCount$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/user/odata-user-count-json-odata-metadata-minimal-odata-streaming-false';
import { odataUserCount$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/user/odata-user-count-json-odata-metadata-minimal-odata-streaming-true';
import { OdataUserCount$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/user/odata-user-count-json-odata-metadata-minimal-odata-streaming-true';
import { odataUserCount$JsonOdataMetadataNone } from '../fn/user/odata-user-count-json-odata-metadata-none';
import { OdataUserCount$JsonOdataMetadataNone$Params } from '../fn/user/odata-user-count-json-odata-metadata-none';
import { odataUserCount$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/user/odata-user-count-json-odata-metadata-none-odata-streaming-false';
import { OdataUserCount$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/user/odata-user-count-json-odata-metadata-none-odata-streaming-false';
import { odataUserCount$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/user/odata-user-count-json-odata-metadata-none-odata-streaming-true';
import { OdataUserCount$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/user/odata-user-count-json-odata-metadata-none-odata-streaming-true';
import { odataUserCount$JsonOdataStreamingFalse } from '../fn/user/odata-user-count-json-odata-streaming-false';
import { OdataUserCount$JsonOdataStreamingFalse$Params } from '../fn/user/odata-user-count-json-odata-streaming-false';
import { odataUserCount$JsonOdataStreamingTrue } from '../fn/user/odata-user-count-json-odata-streaming-true';
import { OdataUserCount$JsonOdataStreamingTrue$Params } from '../fn/user/odata-user-count-json-odata-streaming-true';
import { odataUserCount$Plain } from '../fn/user/odata-user-count-plain';
import { OdataUserCount$Plain$Params } from '../fn/user/odata-user-count-plain';
import { odataUserCount$Xml } from '../fn/user/odata-user-count-xml';
import { OdataUserCount$Xml$Params } from '../fn/user/odata-user-count-xml';
import { UserModel } from '../models/user-model';

@Injectable({ providedIn: 'root' })
export class UserService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiUserPost()` */
  static readonly ApiUserPostPath = '/api/user';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any$Response(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any(params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal$Response(params?: ApiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal(params?: ApiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull$Response(params?: ApiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull(params?: ApiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone$Response(params?: ApiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone(params?: ApiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimal$Json()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$Json$Response(params?: ApiUserPost$JsonOdataMetadataMinimal$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimal$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimal$Json$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$Json(params?: ApiUserPost$JsonOdataMetadataMinimal$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimal$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimal$Xml()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$Xml$Response(params?: ApiUserPost$JsonOdataMetadataMinimal$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimal$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimal$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$Xml(params?: ApiUserPost$JsonOdataMetadataMinimal$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimal$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimal$Plain()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$Plain$Response(params?: ApiUserPost$JsonOdataMetadataMinimal$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimal$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimal$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$Plain(params?: ApiUserPost$JsonOdataMetadataMinimal$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimal$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataMinimal$Any()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$Any$Response(params?: ApiUserPost$JsonOdataMetadataMinimal$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataMinimal$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataMinimal$Any$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUserPost$JsonOdataMetadataMinimal$Any(params?: ApiUserPost$JsonOdataMetadataMinimal$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataMinimal$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Json()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Json$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Json$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Json(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Xml()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Xml$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Xml(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Plain()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Plain$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Plain(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Any()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Any$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Any$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Any(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingTrue$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Json()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Json$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Json$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Json(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Xml()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Xml$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Xml(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Plain()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Plain$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Plain(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Any()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Any$Response(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Any$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Any(params?: ApiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFullOdataStreamingFalse$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal$Response(params?: ApiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal(params?: ApiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFull$Response(params?: ApiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFull(params?: ApiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNone$Response(params?: ApiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNone(params?: ApiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFull$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFull$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$JsonOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataFull$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFull$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFull$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$JsonOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataFull$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFull$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFull$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$JsonOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataFull$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFull$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFull$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$JsonOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataFull$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFull$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFull$Json()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$Json$Response(params?: ApiUserPost$JsonOdataMetadataFull$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFull$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFull$Json$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$Json(params?: ApiUserPost$JsonOdataMetadataFull$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFull$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFull$Xml()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$Xml$Response(params?: ApiUserPost$JsonOdataMetadataFull$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFull$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFull$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$Xml(params?: ApiUserPost$JsonOdataMetadataFull$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFull$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFull$Plain()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$Plain$Response(params?: ApiUserPost$JsonOdataMetadataFull$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFull$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFull$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$Plain(params?: ApiUserPost$JsonOdataMetadataFull$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFull$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataFull$Any()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$Any$Response(params?: ApiUserPost$JsonOdataMetadataFull$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataFull$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataFull$Any$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUserPost$JsonOdataMetadataFull$Any(params?: ApiUserPost$JsonOdataMetadataFull$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataFull$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Json()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Json$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Json$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Json(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Any()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Any$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Any$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Any(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Json()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Json$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Json$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Json(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Any()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Any$Response(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Any$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Any(params?: ApiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal$Response(params?: ApiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal(params?: ApiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFull$Response(params?: ApiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFull(params?: ApiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNone$Response(params?: ApiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNone(params?: ApiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNone$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNone$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$JsonOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataMetadataNone$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNone$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNone$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$JsonOdataStreamingTrue(params?: ApiUserPost$JsonOdataMetadataNone$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNone$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNone$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$JsonOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataMetadataNone$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNone$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNone$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$JsonOdataStreamingFalse(params?: ApiUserPost$JsonOdataMetadataNone$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNone$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNone$Json()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$Json$Response(params?: ApiUserPost$JsonOdataMetadataNone$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNone$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNone$Json$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$Json(params?: ApiUserPost$JsonOdataMetadataNone$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNone$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNone$Xml()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$Xml$Response(params?: ApiUserPost$JsonOdataMetadataNone$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNone$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNone$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$Xml(params?: ApiUserPost$JsonOdataMetadataNone$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNone$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNone$Plain()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$Plain$Response(params?: ApiUserPost$JsonOdataMetadataNone$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNone$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNone$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$Plain(params?: ApiUserPost$JsonOdataMetadataNone$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNone$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataMetadataNone$Any()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$Any$Response(params?: ApiUserPost$JsonOdataMetadataNone$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataMetadataNone$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataMetadataNone$Any$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUserPost$JsonOdataMetadataNone$Any(params?: ApiUserPost$JsonOdataMetadataNone$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataMetadataNone$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal$Response(params?: ApiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal(params?: ApiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFull$Response(params?: ApiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFull(params?: ApiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNone$Response(params?: ApiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNone(params?: ApiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue(params?: ApiUserPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse(params?: ApiUserPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingTrue$Json()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$Json$Response(params?: ApiUserPost$JsonOdataStreamingTrue$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingTrue$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingTrue$Json$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$Json(params?: ApiUserPost$JsonOdataStreamingTrue$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingTrue$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingTrue$Xml()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$Xml$Response(params?: ApiUserPost$JsonOdataStreamingTrue$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingTrue$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingTrue$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$Xml(params?: ApiUserPost$JsonOdataStreamingTrue$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingTrue$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingTrue$Plain()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$Plain$Response(params?: ApiUserPost$JsonOdataStreamingTrue$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingTrue$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingTrue$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$Plain(params?: ApiUserPost$JsonOdataStreamingTrue$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingTrue$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingTrue$Any()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$Any$Response(params?: ApiUserPost$JsonOdataStreamingTrue$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingTrue$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingTrue$Any$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUserPost$JsonOdataStreamingTrue$Any(params?: ApiUserPost$JsonOdataStreamingTrue$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingTrue$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal$Response(params?: ApiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal(params?: ApiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFull$Response(params?: ApiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFull(params?: ApiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNone$Response(params?: ApiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNone(params?: ApiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue$Response(params?: ApiUserPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue(params?: ApiUserPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse$Response(params?: ApiUserPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse(params?: ApiUserPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingFalse$Json()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$Json$Response(params?: ApiUserPost$JsonOdataStreamingFalse$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingFalse$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingFalse$Json$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$Json(params?: ApiUserPost$JsonOdataStreamingFalse$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingFalse$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingFalse$Xml()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$Xml$Response(params?: ApiUserPost$JsonOdataStreamingFalse$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingFalse$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingFalse$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$Xml(params?: ApiUserPost$JsonOdataStreamingFalse$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingFalse$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingFalse$Plain()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$Plain$Response(params?: ApiUserPost$JsonOdataStreamingFalse$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingFalse$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingFalse$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$Plain(params?: ApiUserPost$JsonOdataStreamingFalse$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingFalse$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$JsonOdataStreamingFalse$Any()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$Any$Response(params?: ApiUserPost$JsonOdataStreamingFalse$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$JsonOdataStreamingFalse$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$JsonOdataStreamingFalse$Any$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUserPost$JsonOdataStreamingFalse$Any(params?: ApiUserPost$JsonOdataStreamingFalse$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$JsonOdataStreamingFalse$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiUserPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiUserPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiUserPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiUserPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Json$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$JsonOdataMetadataMinimal$Response(params?: ApiUserPost$Json$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Json$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Json$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$JsonOdataMetadataMinimal(params?: ApiUserPost$Json$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Json$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Json$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiUserPost$Json$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Json$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Json$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiUserPost$Json$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Json$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Json$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiUserPost$Json$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Json$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Json$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiUserPost$Json$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Json$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Json$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$JsonOdataMetadataFull$Response(params?: ApiUserPost$Json$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Json$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Json$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$JsonOdataMetadataFull(params?: ApiUserPost$Json$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Json$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Json$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiUserPost$Json$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Json$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Json$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiUserPost$Json$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Json$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Json$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiUserPost$Json$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Json$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Json$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiUserPost$Json$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Json$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Json$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$JsonOdataMetadataNone$Response(params?: ApiUserPost$Json$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Json$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Json$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$JsonOdataMetadataNone(params?: ApiUserPost$Json$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Json$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Json$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$JsonOdataStreamingTrue$Response(params?: ApiUserPost$Json$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Json$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Json$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$JsonOdataStreamingTrue(params?: ApiUserPost$Json$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Json$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Json$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$JsonOdataStreamingFalse$Response(params?: ApiUserPost$Json$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Json$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Json$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$JsonOdataStreamingFalse(params?: ApiUserPost$Json$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Json$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$Json$Response(params?: ApiUserPost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$Json(params?: ApiUserPost$Json$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$Xml$Response(params?: ApiUserPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$Xml(params?: ApiUserPost$Json$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$Plain$Response(params?: ApiUserPost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$Plain(params?: ApiUserPost$Json$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Json$Any()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$Any$Response(params?: ApiUserPost$Json$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Json$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Json$Any$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUserPost$Json$Any(params?: ApiUserPost$Json$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Json$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Xml$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$JsonOdataMetadataMinimal$Response(params?: ApiUserPost$Xml$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Xml$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Xml$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$JsonOdataMetadataMinimal(params?: ApiUserPost$Xml$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Xml$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Xml$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiUserPost$Xml$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Xml$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Xml$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiUserPost$Xml$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Xml$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Xml$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiUserPost$Xml$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Xml$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Xml$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiUserPost$Xml$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Xml$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Xml$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$JsonOdataMetadataFull$Response(params?: ApiUserPost$Xml$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Xml$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Xml$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$JsonOdataMetadataFull(params?: ApiUserPost$Xml$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Xml$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiUserPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiUserPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiUserPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiUserPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Xml$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$JsonOdataMetadataNone$Response(params?: ApiUserPost$Xml$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Xml$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Xml$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$JsonOdataMetadataNone(params?: ApiUserPost$Xml$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Xml$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Xml$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$JsonOdataStreamingTrue$Response(params?: ApiUserPost$Xml$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Xml$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Xml$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$JsonOdataStreamingTrue(params?: ApiUserPost$Xml$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Xml$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Xml$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$JsonOdataStreamingFalse$Response(params?: ApiUserPost$Xml$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Xml$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Xml$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$JsonOdataStreamingFalse(params?: ApiUserPost$Xml$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Xml$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Xml$Json()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$Json$Response(params?: ApiUserPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Xml$Json$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$Json(params?: ApiUserPost$Xml$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Xml$Xml()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$Xml$Response(params?: ApiUserPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$Xml(params?: ApiUserPost$Xml$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Xml$Plain()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$Plain$Response(params?: ApiUserPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$Plain(params?: ApiUserPost$Xml$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Xml$Any()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$Any$Response(params?: ApiUserPost$Xml$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Xml$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Xml$Any$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUserPost$Xml$Any(params?: ApiUserPost$Xml$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Xml$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Plain$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$JsonOdataMetadataMinimal$Response(params?: ApiUserPost$Plain$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Plain$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Plain$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$JsonOdataMetadataMinimal(params?: ApiUserPost$Plain$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Plain$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Plain$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiUserPost$Plain$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Plain$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Plain$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiUserPost$Plain$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Plain$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Plain$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiUserPost$Plain$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Plain$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Plain$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiUserPost$Plain$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Plain$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Plain$JsonOdataMetadataFull()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$JsonOdataMetadataFull$Response(params?: ApiUserPost$Plain$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Plain$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Plain$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$JsonOdataMetadataFull(params?: ApiUserPost$Plain$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Plain$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiUserPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiUserPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiUserPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiUserPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Plain$JsonOdataMetadataNone()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$JsonOdataMetadataNone$Response(params?: ApiUserPost$Plain$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Plain$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Plain$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$JsonOdataMetadataNone(params?: ApiUserPost$Plain$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Plain$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Plain$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$JsonOdataStreamingTrue$Response(params?: ApiUserPost$Plain$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Plain$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Plain$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$JsonOdataStreamingTrue(params?: ApiUserPost$Plain$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Plain$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Plain$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$JsonOdataStreamingFalse$Response(params?: ApiUserPost$Plain$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Plain$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Plain$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$JsonOdataStreamingFalse(params?: ApiUserPost$Plain$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Plain$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Plain$Json()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$Json$Response(params?: ApiUserPost$Plain$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Plain$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Plain$Json$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$Json(params?: ApiUserPost$Plain$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Plain$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Plain$Xml()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$Xml$Response(params?: ApiUserPost$Plain$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Plain$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Plain$Xml$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$Xml(params?: ApiUserPost$Plain$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Plain$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Plain$Plain()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$Plain$Response(params?: ApiUserPost$Plain$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Plain$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Plain$Plain$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$Plain(params?: ApiUserPost$Plain$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Plain$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPost$Plain$Any()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$Any$Response(params?: ApiUserPost$Plain$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUserPost$Plain$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPost$Plain$Any$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUserPost$Plain$Any(params?: ApiUserPost$Plain$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUserPost$Plain$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /** Path part for operation `apiUpsertUserPost()` */
  static readonly ApiUpsertUserPostPath = '/api/upsert-user';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=true` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal;odata.streaming=false` and handles request body of type `application/json;odata.metadata=minimal;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any(params?: ApiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimalOdataStreamingFalse$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimal$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimal$Json()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$Json$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimal$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimal$Json$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$Json(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimal$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimal$Xml()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$Xml$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimal$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimal$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$Xml(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimal$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimal$Plain()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$Plain$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimal$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimal$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$Plain(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimal$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataMinimal$Any()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$Any$Response(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataMinimal$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataMinimal$Any$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=minimal` and handles request body of type `application/json;odata.metadata=minimal`.
   */
  apiUpsertUserPost$JsonOdataMetadataMinimal$Any(params?: ApiUpsertUserPost$JsonOdataMetadataMinimal$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataMinimal$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Json()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Json$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Json$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Json(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Xml()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Xml$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Xml(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Plain()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Plain$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Plain(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Any()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Any$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Any$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=true` and handles request body of type `application/json;odata.metadata=full;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Any(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingTrue$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Json()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Json$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Json$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Json(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Xml()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Xml$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Xml(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Plain()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Plain$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Plain(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Any()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Any$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Any$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full;odata.streaming=false` and handles request body of type `application/json;odata.metadata=full;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Any(params?: ApiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFullOdataStreamingFalse$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal(params?: ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFull$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFull(params?: ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNone$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNone(params?: ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataFull$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFull$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFull$Json()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$Json$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFull$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFull$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFull$Json$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$Json(params?: ApiUpsertUserPost$JsonOdataMetadataFull$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFull$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFull$Xml()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$Xml$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFull$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFull$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFull$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$Xml(params?: ApiUpsertUserPost$JsonOdataMetadataFull$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFull$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFull$Plain()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$Plain$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFull$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFull$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFull$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$Plain(params?: ApiUpsertUserPost$JsonOdataMetadataFull$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFull$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataFull$Any()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$Any$Response(params?: ApiUpsertUserPost$JsonOdataMetadataFull$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataFull$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataFull$Any$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=full` and handles request body of type `application/json;odata.metadata=full`.
   */
  apiUpsertUserPost$JsonOdataMetadataFull$Any(params?: ApiUpsertUserPost$JsonOdataMetadataFull$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataFull$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Json()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Json$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Json$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Json(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Any()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Any$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Any$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=true` and handles request body of type `application/json;odata.metadata=none;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Any(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingTrue$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Json()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Json$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Json$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Json(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Any()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Any$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Any$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none;odata.streaming=false` and handles request body of type `application/json;odata.metadata=none;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Any(params?: ApiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNoneOdataStreamingFalse$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal(params?: ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFull$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFull(params?: ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNone$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNone(params?: ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataMetadataNone$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNone$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNone$Json()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$Json$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNone$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNone$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNone$Json$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$Json(params?: ApiUpsertUserPost$JsonOdataMetadataNone$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNone$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNone$Xml()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$Xml$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNone$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNone$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNone$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$Xml(params?: ApiUpsertUserPost$JsonOdataMetadataNone$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNone$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNone$Plain()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$Plain$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNone$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNone$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNone$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$Plain(params?: ApiUpsertUserPost$JsonOdataMetadataNone$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNone$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataMetadataNone$Any()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$Any$Response(params?: ApiUpsertUserPost$JsonOdataMetadataNone$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataMetadataNone$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataMetadataNone$Any$Response()` instead.
   *
   * This method sends `application/json;odata.metadata=none` and handles request body of type `application/json;odata.metadata=none`.
   */
  apiUpsertUserPost$JsonOdataMetadataNone$Any(params?: ApiUpsertUserPost$JsonOdataMetadataNone$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataMetadataNone$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal$Response(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFull$Response(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFull(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNone$Response(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNone(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingTrue$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingTrue$Json()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$Json$Response(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingTrue$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingTrue$Json$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$Json(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingTrue$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingTrue$Xml()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$Xml$Response(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingTrue$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingTrue$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$Xml(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingTrue$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingTrue$Plain()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$Plain$Response(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingTrue$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingTrue$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$Plain(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingTrue$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingTrue$Any()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$Any$Response(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingTrue$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingTrue$Any$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=true` and handles request body of type `application/json;odata.streaming=true`.
   */
  apiUpsertUserPost$JsonOdataStreamingTrue$Any(params?: ApiUpsertUserPost$JsonOdataStreamingTrue$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingTrue$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal$Response(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFull$Response(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFull(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNone$Response(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNone(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue$Response(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse$Response(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingFalse$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingFalse$Json()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$Json$Response(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingFalse$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingFalse$Json$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$Json(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingFalse$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingFalse$Xml()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$Xml$Response(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingFalse$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingFalse$Xml$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$Xml(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingFalse$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingFalse$Plain()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$Plain$Response(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingFalse$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingFalse$Plain$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$Plain(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingFalse$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$JsonOdataStreamingFalse$Any()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$Any$Response(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$JsonOdataStreamingFalse$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$JsonOdataStreamingFalse$Any$Response()` instead.
   *
   * This method sends `application/json;odata.streaming=false` and handles request body of type `application/json;odata.streaming=false`.
   */
  apiUpsertUserPost$JsonOdataStreamingFalse$Any(params?: ApiUpsertUserPost$JsonOdataStreamingFalse$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$JsonOdataStreamingFalse$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiUpsertUserPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiUpsertUserPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Json$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiUpsertUserPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiUpsertUserPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Json$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Json$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$JsonOdataMetadataMinimal$Response(params?: ApiUpsertUserPost$Json$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Json$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Json$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$JsonOdataMetadataMinimal(params?: ApiUpsertUserPost$Json$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Json$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Json$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiUpsertUserPost$Json$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Json$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Json$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiUpsertUserPost$Json$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Json$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Json$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiUpsertUserPost$Json$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Json$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Json$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiUpsertUserPost$Json$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Json$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Json$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$JsonOdataMetadataFull$Response(params?: ApiUpsertUserPost$Json$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Json$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Json$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$JsonOdataMetadataFull(params?: ApiUpsertUserPost$Json$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Json$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Json$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiUpsertUserPost$Json$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Json$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Json$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiUpsertUserPost$Json$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Json$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Json$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiUpsertUserPost$Json$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Json$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Json$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiUpsertUserPost$Json$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Json$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Json$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$JsonOdataMetadataNone$Response(params?: ApiUpsertUserPost$Json$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Json$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Json$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$JsonOdataMetadataNone(params?: ApiUpsertUserPost$Json$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Json$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Json$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$JsonOdataStreamingTrue$Response(params?: ApiUpsertUserPost$Json$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Json$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Json$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$JsonOdataStreamingTrue(params?: ApiUpsertUserPost$Json$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Json$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Json$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$JsonOdataStreamingFalse$Response(params?: ApiUpsertUserPost$Json$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Json$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Json$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$JsonOdataStreamingFalse(params?: ApiUpsertUserPost$Json$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Json$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$Json$Response(params?: ApiUpsertUserPost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$Json(params?: ApiUpsertUserPost$Json$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$Xml$Response(params?: ApiUpsertUserPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$Xml(params?: ApiUpsertUserPost$Json$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$Plain$Response(params?: ApiUpsertUserPost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$Plain(params?: ApiUpsertUserPost$Json$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Json$Any()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$Any$Response(params?: ApiUpsertUserPost$Json$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Json$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Json$Any$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUpsertUserPost$Json$Any(params?: ApiUpsertUserPost$Json$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Json$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiUpsertUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiUpsertUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiUpsertUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiUpsertUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Xml$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Xml$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$JsonOdataMetadataMinimal$Response(params?: ApiUpsertUserPost$Xml$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Xml$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Xml$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$JsonOdataMetadataMinimal(params?: ApiUpsertUserPost$Xml$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Xml$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Xml$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiUpsertUserPost$Xml$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Xml$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Xml$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiUpsertUserPost$Xml$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Xml$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Xml$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiUpsertUserPost$Xml$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Xml$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Xml$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiUpsertUserPost$Xml$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Xml$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Xml$JsonOdataMetadataFull()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$JsonOdataMetadataFull$Response(params?: ApiUpsertUserPost$Xml$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Xml$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Xml$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$JsonOdataMetadataFull(params?: ApiUpsertUserPost$Xml$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Xml$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiUpsertUserPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiUpsertUserPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Xml$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiUpsertUserPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiUpsertUserPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Xml$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Xml$JsonOdataMetadataNone()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$JsonOdataMetadataNone$Response(params?: ApiUpsertUserPost$Xml$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Xml$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Xml$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$JsonOdataMetadataNone(params?: ApiUpsertUserPost$Xml$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Xml$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Xml$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$JsonOdataStreamingTrue$Response(params?: ApiUpsertUserPost$Xml$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Xml$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Xml$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$JsonOdataStreamingTrue(params?: ApiUpsertUserPost$Xml$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Xml$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Xml$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$JsonOdataStreamingFalse$Response(params?: ApiUpsertUserPost$Xml$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Xml$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Xml$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$JsonOdataStreamingFalse(params?: ApiUpsertUserPost$Xml$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Xml$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Xml$Json()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$Json$Response(params?: ApiUpsertUserPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Xml$Json$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$Json(params?: ApiUpsertUserPost$Xml$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Xml$Xml()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$Xml$Response(params?: ApiUpsertUserPost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$Xml(params?: ApiUpsertUserPost$Xml$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Xml$Plain()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$Plain$Response(params?: ApiUpsertUserPost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$Plain(params?: ApiUpsertUserPost$Xml$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Xml$Any()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$Any$Response(params?: ApiUpsertUserPost$Xml$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Xml$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Xml$Any$Response()` instead.
   *
   * This method sends `application/xml` and handles request body of type `application/xml`.
   */
  apiUpsertUserPost$Xml$Any(params?: ApiUpsertUserPost$Xml$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Xml$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiUpsertUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiUpsertUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiUpsertUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiUpsertUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Plain$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Plain$JsonOdataMetadataMinimal()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$JsonOdataMetadataMinimal$Response(params?: ApiUpsertUserPost$Plain$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Plain$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Plain$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$JsonOdataMetadataMinimal(params?: ApiUpsertUserPost$Plain$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Plain$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Plain$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiUpsertUserPost$Plain$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Plain$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Plain$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiUpsertUserPost$Plain$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Plain$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Plain$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiUpsertUserPost$Plain$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Plain$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Plain$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiUpsertUserPost$Plain$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Plain$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Plain$JsonOdataMetadataFull()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$JsonOdataMetadataFull$Response(params?: ApiUpsertUserPost$Plain$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Plain$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Plain$JsonOdataMetadataFull$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$JsonOdataMetadataFull(params?: ApiUpsertUserPost$Plain$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Plain$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiUpsertUserPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiUpsertUserPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Plain$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiUpsertUserPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiUpsertUserPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Plain$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Plain$JsonOdataMetadataNone()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$JsonOdataMetadataNone$Response(params?: ApiUpsertUserPost$Plain$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Plain$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Plain$JsonOdataMetadataNone$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$JsonOdataMetadataNone(params?: ApiUpsertUserPost$Plain$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Plain$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Plain$JsonOdataStreamingTrue()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$JsonOdataStreamingTrue$Response(params?: ApiUpsertUserPost$Plain$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Plain$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Plain$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$JsonOdataStreamingTrue(params?: ApiUpsertUserPost$Plain$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Plain$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Plain$JsonOdataStreamingFalse()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$JsonOdataStreamingFalse$Response(params?: ApiUpsertUserPost$Plain$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Plain$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Plain$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$JsonOdataStreamingFalse(params?: ApiUpsertUserPost$Plain$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Plain$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Plain$Json()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$Json$Response(params?: ApiUpsertUserPost$Plain$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Plain$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Plain$Json$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$Json(params?: ApiUpsertUserPost$Plain$Json$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Plain$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Plain$Xml()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$Xml$Response(params?: ApiUpsertUserPost$Plain$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Plain$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Plain$Xml$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$Xml(params?: ApiUpsertUserPost$Plain$Xml$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Plain$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Plain$Plain()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$Plain$Response(params?: ApiUpsertUserPost$Plain$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Plain$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Plain$Plain$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$Plain(params?: ApiUpsertUserPost$Plain$Plain$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Plain$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUpsertUserPost$Plain$Any()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$Any$Response(params?: ApiUpsertUserPost$Plain$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
    return apiUpsertUserPost$Plain$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUpsertUserPost$Plain$Any$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  apiUpsertUserPost$Plain$Any(params?: ApiUpsertUserPost$Plain$Any$Params, context?: HttpContext): Observable<ObjectResult> {
    return this.apiUpsertUserPost$Plain$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ObjectResult>): ObjectResult => r.body)
    );
  }

  /** Path part for operation `apiUserPermissionsGet()` */
  static readonly ApiUserPermissionsGetPath = '/api/user/permissions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUserPermissionsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUserPermissionsGet$Response(params?: ApiUserPermissionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiUserPermissionsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUserPermissionsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUserPermissionsGet(params?: ApiUserPermissionsGet$Params, context?: HttpContext): Observable<void> {
    return this.apiUserPermissionsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `odataUser()` */
  static readonly OdataUserPath = '/odata/user';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUser$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: OdataUser$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUser$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUser$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$JsonOdataMetadataMinimalOdataStreamingTrue(params?: OdataUser$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUser$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUser$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: OdataUser$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUser$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUser$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$JsonOdataMetadataMinimalOdataStreamingFalse(params?: OdataUser$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUser$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUser$JsonOdataMetadataMinimal()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$JsonOdataMetadataMinimal$Response(params?: OdataUser$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUser$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUser$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$JsonOdataMetadataMinimal(params?: OdataUser$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUser$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUser$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: OdataUser$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUser$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUser$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$JsonOdataMetadataFullOdataStreamingTrue(params?: OdataUser$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUser$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUser$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: OdataUser$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUser$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUser$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$JsonOdataMetadataFullOdataStreamingFalse(params?: OdataUser$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUser$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUser$JsonOdataMetadataFull()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$JsonOdataMetadataFull$Response(params?: OdataUser$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUser$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUser$JsonOdataMetadataFull$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$JsonOdataMetadataFull(params?: OdataUser$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUser$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUser$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: OdataUser$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUser$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUser$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$JsonOdataMetadataNoneOdataStreamingTrue(params?: OdataUser$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUser$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUser$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: OdataUser$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUser$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUser$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$JsonOdataMetadataNoneOdataStreamingFalse(params?: OdataUser$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUser$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUser$JsonOdataMetadataNone()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$JsonOdataMetadataNone$Response(params?: OdataUser$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUser$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUser$JsonOdataMetadataNone$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$JsonOdataMetadataNone(params?: OdataUser$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUser$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUser$JsonOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$JsonOdataStreamingTrue$Response(params?: OdataUser$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUser$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUser$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$JsonOdataStreamingTrue(params?: OdataUser$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUser$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUser$JsonOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$JsonOdataStreamingFalse$Response(params?: OdataUser$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUser$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUser$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$JsonOdataStreamingFalse(params?: OdataUser$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUser$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUser$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$Json$Response(params?: OdataUser$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUser$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUser$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$Json(params?: OdataUser$Json$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUser$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUser$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$Xml$Response(params?: OdataUser$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUser$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUser$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$Xml(params?: OdataUser$Xml$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUser$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUser$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$Plain$Response(params?: OdataUser$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUser$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUser$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$Plain(params?: OdataUser$Plain$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUser$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUser$Any()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$Any$Response(params?: OdataUser$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUser$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUser$Any$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUser$Any(params?: OdataUser$Any$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUser$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /** Path part for operation `odataUserCount()` */
  static readonly OdataUserCountPath = '/odata/user/$count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUserCount$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: OdataUserCount$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUserCount$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUserCount$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$JsonOdataMetadataMinimalOdataStreamingTrue(params?: OdataUserCount$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUserCount$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUserCount$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: OdataUserCount$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUserCount$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUserCount$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$JsonOdataMetadataMinimalOdataStreamingFalse(params?: OdataUserCount$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUserCount$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUserCount$JsonOdataMetadataMinimal()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$JsonOdataMetadataMinimal$Response(params?: OdataUserCount$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUserCount$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUserCount$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$JsonOdataMetadataMinimal(params?: OdataUserCount$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUserCount$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUserCount$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: OdataUserCount$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUserCount$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUserCount$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$JsonOdataMetadataFullOdataStreamingTrue(params?: OdataUserCount$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUserCount$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUserCount$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: OdataUserCount$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUserCount$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUserCount$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$JsonOdataMetadataFullOdataStreamingFalse(params?: OdataUserCount$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUserCount$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUserCount$JsonOdataMetadataFull()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$JsonOdataMetadataFull$Response(params?: OdataUserCount$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUserCount$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUserCount$JsonOdataMetadataFull$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$JsonOdataMetadataFull(params?: OdataUserCount$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUserCount$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUserCount$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: OdataUserCount$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUserCount$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUserCount$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$JsonOdataMetadataNoneOdataStreamingTrue(params?: OdataUserCount$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUserCount$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUserCount$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: OdataUserCount$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUserCount$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUserCount$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$JsonOdataMetadataNoneOdataStreamingFalse(params?: OdataUserCount$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUserCount$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUserCount$JsonOdataMetadataNone()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$JsonOdataMetadataNone$Response(params?: OdataUserCount$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUserCount$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUserCount$JsonOdataMetadataNone$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$JsonOdataMetadataNone(params?: OdataUserCount$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUserCount$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUserCount$JsonOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$JsonOdataStreamingTrue$Response(params?: OdataUserCount$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUserCount$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUserCount$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$JsonOdataStreamingTrue(params?: OdataUserCount$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUserCount$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUserCount$JsonOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$JsonOdataStreamingFalse$Response(params?: OdataUserCount$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUserCount$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUserCount$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$JsonOdataStreamingFalse(params?: OdataUserCount$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUserCount$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUserCount$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$Json$Response(params?: OdataUserCount$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUserCount$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUserCount$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$Json(params?: OdataUserCount$Json$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUserCount$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUserCount$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$Xml$Response(params?: OdataUserCount$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUserCount$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUserCount$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$Xml(params?: OdataUserCount$Xml$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUserCount$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUserCount$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$Plain$Response(params?: OdataUserCount$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUserCount$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUserCount$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$Plain(params?: OdataUserCount$Plain$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUserCount$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `odataUserCount$Any()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$Any$Response(params?: OdataUserCount$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserModel>>> {
    return odataUserCount$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `odataUserCount$Any$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  odataUserCount$Any(params?: OdataUserCount$Any$Params, context?: HttpContext): Observable<Array<UserModel>> {
    return this.odataUserCount$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserModel>>): Array<UserModel> => r.body)
    );
  }

}
